import { Component, ViewChild, HostBinding } from "@angular/core";
import { UpgradableComponent } from "theme/components/upgradable";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
//import { TicketsService, TicketData } from "../../../services";
import { Router } from "@angular/router";
import { ContractData, ContractsService } from "../../services";


@Component({
  selector: "contracts",
  templateUrl: "contracts.component.html",
  styleUrls: ["contracts.component.scss"],
})
export class ContractsComponent extends UpgradableComponent {
  @HostBinding("class.mdl-grid") private readonly mdlGrid = true;
  @HostBinding("class.mdl-cell") private readonly mdlCell = true;
  @HostBinding("class.mdl-cell--12-col-desktop") private readonly mdlCell12ColDesktop = true;
  @HostBinding("class.mdl-cell--12-col-tablet") private readonly mdlCell12ColTablet = true;
  @HostBinding("class.mdl-cell--4-col-phone") private readonly mdlCell4ColPhone = true;
  @HostBinding("class.mdl-cell--top") private readonly mdlCellTop = true;
  @HostBinding("class.ui-tables") private readonly uiTables = true;

  displayedColumns: string[] = ["contractNo", "customer", "starts", "ends", "sla"];
  openResponseDataSource = new MatTableDataSource<ContractData>();

  @ViewChild(MatPaginator) set paginator(matPaginator: MatPaginator) {
    this.openResponseDataSource.paginator = matPaginator;
  }
  @ViewChild(MatSort) set sort(matSort: MatSort) {
    this.openResponseDataSource.sort = matSort;
  }

  loading = false;
  noTickets = false;

  public constructor(private readonly tablesService: ContractsService,
    private readonly router: Router) {
    super();
    this.loading = true;
    if (this.tablesService.isAdmin()) {
      this.displayedColumns = ["contractNo", "customer", "starts", "ends", "sla"];
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.openResponseDataSource.filter = filterValue.trim().toLowerCase();
  }

  ngAfterViewInit() {

    this.tablesService.getContracts().subscribe(result => {
      if (result.length === 0) {
        this.noTickets = true;
      }
      this.openResponseDataSource = new MatTableDataSource<ContractData>(result);
      this.loading = false;
    });
  }


  getDetails(row: ContractData) {
    this.router.navigate(["app/assets/" + row.contractNo]);
  }
}
